<template>
<div>
  <v-dialog title="본인인증" v-model="perCertDialog" persistent max-width="460px" width="460px">
    <div id="wrap">
      <!--
      <form id="pereCertForm" ref="perCertForm" target="perCertFrame" :action="perCertURL + perSubURL">
        <input type = "hidden" name="cpCd" :value="cpCd"/>
        <input type = "hidden"  name="siteName" :value="siteName"/>
        <input type = "hidden"  name="siteUrl" :value="siteUrl"/>
      </form>
      <iframe
        width="100%"
        name="perCertFrame"
        height="650px"
        style="border:none">
      </iframe>
      -->
    </div>
  </v-dialog>
</div>
</template>
<script>
export default {
  name: 'perCert',
  components: {
  },
  filters: {
  },
  props:{
    perName: String,
    perNumber: String
  },
  data () {
    return {
      perCertDialog: false,
      perCertURL: process.env.VUE_APP_URL_AUTH,
      perSubURL: '/perCertificate/auth',
      result: null,
      // 회원사코드
      cpCd: 'P20900000001',
      // 요청사이트명
      siteName: 'smartsign',
      // 요청 URL
      siteUrl: 'sign.smartbill.co.kr'
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    open() {
      this.perCertDialog = true
      setTimeout(this.pubOpen, 1000);
    },
    close () {
      this.perCertDialog = false
    },
    pubOpen () {
      window.addEventListener('message', this.perCertResult, true)
      this.$nextTick(() => {
        // this.$refs.perCertForm.submit()
        var popupWidth = 400;
        var popupHeight = 600;
        var popupX = (window.screen.width / 2) - (popupWidth / 2);
        var popupY= (window.screen.height / 2) - (popupHeight / 2);
        window.open(
          this.perCertURL + this.perSubURL + "?cpCd=" + this.cpCd + "&siteName=" + this.siteName + "&siteUrl=" + this.siteUrl,
          "_blank", "height=" + popupHeight  + ", width=" + popupWidth  + ", left="+ popupX + ", top="+ popupY
        );
      })
    },
    perCertResult (result) {
      console.log("perCertResult", result);
      this.perCertDialog = false
      var data = result.data
      this.$nextTick(() => {
        if (data.rsltCode === 'B000') {
          console.log("data.rsltName", data.rsltName);
          console.log("this.perName", this.perName);
          console.log("data.rsltTel", data.rsltTel);
          console.log("this.perNumber", this.perNumber);
          if(this.perName === data.rsltName && this.perNumber === data.rsltTel) {
            this.$emit('per-event', true, data.rsltCi)
          }else{
            this.$emit('per-event', false, "인증 정보가 일치하지 않습니다.")
          }
        }else{
          this.$emit('per-event', false, data.result.message)
        }
      })
    }
  }
}
</script>

